<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="payment__history wallet-loader">
    <div class="card wavebg mb-24">
      <div class="payment-card__up !tw-flex !tw-justify-between">
        <h4 class="mt-0 mr-16">
          Your Balance
        </h4>
        <div class="!tw-flex payment-card__up-content texts-btn__wrap">
          <div class="!tw-flex payment-card__up-content !tw-items-center">
            <h5 class="mr-16 pr-16">
              PAYMENT PERIOD: <span>MANUAL</span>
            </h5>
            <h5 class="mr-16">
              NEGATIVE CARRYOVER: <span class="text-green">Yes</span>
            </h5>
          </div>
          <div class="">
            <button class="btn btn-primary btn-sm">
              Request Payment
            </button>
          </div>
        </div>
      </div>
      <div class="payment-card__down row">
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5 class="head text-info">
              In Hold
            </h5>
            <h4 class="data">
              $0.00
            </h4>
          </div>
        </div>
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5 class="head text-success">
              Available
            </h5>
            <h4 class="data">
              $0.00
            </h4>
          </div>
        </div>
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5
              style="color: #cd8a0c;"
              class="head"
            >
              Pending Payment
            </h5>
            <h4 class="data">
              $0.00
            </h4>
          </div>
        </div>
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5 class="head text-black">
              Paid In Total
            </h5>
            <h4 class="data">
              $0.00
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="card wavebg !tw-w-full">
      <div class="wallet-header !tw-justify-between">
        <div class="header-left">
          <div class="!tw-flex !tw-items-center">
            <label class="mb-0">Period</label>
            <div class="empty-select mr-16 ml-6">
              Not Specified
            </div>
          </div>
          <div class="checkbox">
            <input
              id="checkbox-empty"
              type="checkbox"
            >
            <label
              for="checkbox-empty"
              class="checkbox-label mb-0"
            >Show Only Withdrawals</label>
          </div>
        </div>
        <div class="header-right">
          <div
            class="empty-pagination ml-8"
            style="width: 269px"
          >
            <div
              class="empty-select mr-8"
              style="width: 80px"
            >
              100
            </div>
            <span>&lt; &lt;&lt; Page</span>
            <div class="form-group mb-0 mt-0">
              <input
                placeholder="1"
                class="form-control mt-0 pl-16 pr-16"
                style="width: 40px"
              >
            </div>
            <span>of 2 > >></span>
          </div>
        </div>
      </div>
      <div class="filter-search pb-24">
        Filter & Search
      </div>


      <div class="table-empty mt-16 mb-8">
        <div class="table-empty__head">
          <!-- <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Actions</div> -->
        </div>
        <div class="table-empty__body">
          <!-- <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div> -->
        </div>

        <div class="mob-table__block mob-table__block-first pt-0">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
        <div class="mob-table__block">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
        <div class="mob-table__block">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
// @import 'src/assets/theme/default/components/styles-loaders';

.wallet-loader{
  .wallet-header, .header-left, .header-right{
    display: flex;
    align-items: center;
  }
  .filter-search{
    display: none;
  }
  @media (max-width: 1150px){
    .header-left, .header-right{
      flex-direction: column;
      .empty-pagination, .checkbox{
        margin-top: 10px !important;
      }
    }
    .header-left{
      align-items: flex-start;
    }
    .header-right{
      align-items: flex-end;
    }
  }
  @media (max-width: 650px){
    .wallet-header{
      display: none;
    }
    .filter-search{
      display: block;
      border-bottom: 1px solid #e7ecf1;
    }
  }
}
</style>
